import React from "react";
import { useGlobalContext } from "../context";
import { Link, useHistory } from "react-router-dom";
import logo from "../assets/logo.webp";

const Navbar = () => {
  const history = useHistory();
  const { user, logout } = useGlobalContext();
  const handleLogout = async () => {
    await logout();
    history.push("/login");
  };
  return (
    <nav className="navbar navbar-dark bg-primary py-1 d-print-none">
      <div className="container-lg">
        <Link className="navbar-brand mb-0" to="/">
          <img
            src={logo}
            alt="Logo"
            height={36}
            className="me-2 rounded p-1 bg-white"
          />
          CSRE
        </Link>
        <ul className="navbar-nav flex-row">
          {user.id ? (
            <li className="nav-item">
              <button
                className="btn btn-outline-light btn-sm px-3"
                onClick={handleLogout}
              >
                Log out
              </button>
            </li>
          ) : (
            <li className="nav-item">
              <Link className="btn btn-outline-light btn-sm px-3" to="/login">
                Login
              </Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
